import { useGetOrganizationList } from '@forwardflow/hooks/customHooks'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import LocalStorage from '@forwardflow/services/LocalStorage'
import { Spinner } from '@forwardflow/ui'
import { UserAvatar } from '@forwardflow/ui/Avatar'
import { message, Select } from 'antd'
import { useEffect, useState } from 'react'

type OnboardingType = {
   children?: React.ReactNode
   avatar?: boolean
   className?: string
}

const OnboardingContainer: React.FC<OnboardingType> = ({
   children,
   avatar = true,
   className,
}) => {
   const { data: user } = useAuthUser({ revalidateOnMount: true })
   const [organizationParams, setOrganizationParams] = useState({
      page: 1,
      limit: 10,
   })
   const selectedOrganization = LocalStorage.get(
      'currentOrganization'
   ) as string

   const shouldFetch =
      user?.email === 'operator@forward-flow.com' ||
      user?.email === 'brannon@forward-flow.com' ||
      user?.email === 'engineered@forward-flow.com'

   const onSelectOrganization = (value: string) => {
      try {
         LocalStorage.put('currentOrganization', value)
         message.success('Organization changed successfully')
         setTimeout(() => {
            window.location.href = '/onboarding'
         }, 1000)
      } catch (error) {
         console.log('error', error)
      }
   }

   const { data: organizationList, isLoading } = useGetOrganizationList({
      ...organizationParams,
      shouldFetch,
   })

   const loadMoreOrganizations = () => {
      setOrganizationParams((prev) => ({
         ...prev,
         page: prev.page + 1,
      }))
   }

   const [allOrganizations, setAllOrganizations] = useState<any[]>([])

   useEffect(() => {
      if (organizationList && organizationList.length > 0) {
         setAllOrganizations((prev) => {
            const combined = [...prev, ...organizationList]

            return Array.from(
               new Map(combined.map((item) => [item.id, item])).values()
            )
         })
      }
   }, [organizationList])

   const organizationOptions = allOrganizations?.map((item) => {
      return {
         value: item.id,
         label: item.organizationName + ' - ' + item.id,
      }
   })

   // Auto-select first organization if none is selected
   useEffect(() => {
      if (
         !selectedOrganization &&
         organizationOptions &&
         organizationOptions.length > 0
      ) {
         onSelectOrganization(organizationOptions[0].value)
      }
   }, [organizationOptions, selectedOrganization])

   // Show spinner if no organization is selected
   if (!selectedOrganization && shouldFetch) {
      return (
         <div className="flex items-center justify-center min-h-screen">
            <Spinner />
         </div>
      )
   }

   return (
      <>
         <div
            className={`flex min-h-screen px-4 lg:px-[30px] flex-col  items-center text-center pt-14 md:pt-28 ${className}`}
         >
            {avatar && <UserAvatar />}
            <a href="/">
               <img
                  width={'165px'}
                  src="/images/fff-logo.png"
                  className="md:absolute left-10 top-10"
                  alt="ff icon"
               />
            </a>
            <div className="absolute top-10 right-10">
               {shouldFetch && (
                  <Select
                     className="ml-[10px] w-[120px] lg:w-[200px] dashboard-select"
                     placeholder="Select Organization"
                     options={organizationOptions}
                     onChange={onSelectOrganization}
                     value={selectedOrganization || ''}
                     loading={isLoading}
                     onPopupScroll={(e) => {
                        const target = e.target as HTMLDivElement
                        if (
                           target.scrollTop + target.offsetHeight >=
                           target.scrollHeight - 20
                        ) {
                           loadMoreOrganizations()
                        }
                     }}
                  ></Select>
               )}
            </div>

            {/* <img
          src="/images/ff-icon.webp"
          className="mt-16 md:mt-28 w-20 md:w-[98px]"
          alt="ff icon"
        /> */}
            {children}
         </div>
      </>
   )
}

export default OnboardingContainer
